import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { required, maxLength} from "vuelidate/lib/validators";
import CONFIG from "@/assets/js/config.js";
import ShiftPatternService from "@/services/ShiftPatternService";
import ValidationService from "@/services/ValidationService";

export default {
  name: "shiftPatternCreate",
  mixins: [ValidationService],
  directives: {
    error: {
      bind(el, binding) {
        removeValidationError(el);
        if (binding.value) {
          insertValidationError(el, binding.value);
        }
      },
      inserted(el, binding) {
        removeValidationError(el);
        if (binding.value) {
          insertValidationError(el, binding.value);
        }
      },
      componentUpdated(el, binding) {
        removeValidationError(el);
        if (binding.value) {
          insertValidationError(el, binding.value);
        }
      },
    },
  },
  components: {
      MainLayout,
      Loading
  },

  data() {
    return {
      isLoading: false,
      shiftLists: {},
      pattern_name: "",
      pattern_group: null,
      days: CONFIG.DAYS,
      selectedShiftsByDay: {},
      selectedDays: {},
      submitted: false,
      disabled: false,
      shiftErrorData: {},
    };
  },

  validations: {
    pattern_name: {
      required,
      maxLength: maxLength(100)
    }
  },

  methods: {
    clearValidationErrors() {
      this.validationErrors = {};
      const root = this.$el || document;
      const errorEls = root.querySelectorAll('.validation-error');
      errorEls.forEach(el => el.remove());
    },

    showList() {
      this.$router.push({
        name : "shiftPatternList"
      });
    },

    dayHasError(dayId) {
      return ShiftPatternService.dayHasError(dayId, this.selectedDays, this.selectedShiftsByDay, this.submitted)
    },

    shiftHasError(dayId) {
      return ShiftPatternService.shiftHasError(dayId, this.selectedDays, this.selectedShiftsByDay, this.submitted)
    },

    changeTimeFormat(time) {
      return ShiftPatternService.changeTimeFormat(time);
    },

    getShiftLists() {
      this.isLoading = true;
      axios.get("/shift/setting/by-time")
      .then((response) => {
        this.shiftLists = response.data.shifts;
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.log(err)
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    async confirmCreatePattern() {
      this.clearValidationErrors();
      this.submitted = true;
      this.disabled = true;
      if (this.$v.invalid || this.pattern_name == '') {
        this.disabled = false;
        return;
      }
      const dayErrorExists = Object.keys(this.selectedDays).some(dayId =>
        ShiftPatternService.dayHasError(dayId,
          this.selectedDays,
          this.selectedShiftsByDay,
          this.submitted) || ShiftPatternService.shiftHasError(dayId, this.selectedDays, this.selectedShiftsByDay, this.submitted)
      );
      if (dayErrorExists) {
        this.disabled = false;
        return;
      }
      this.createPattern();
    },

    isShiftOverlapped(shiftId, dayId) {
      return ShiftPatternService.defineShiftOverlapped(shiftId, dayId, this.shiftErrorData, this.selectedShiftsByDay)
    },

    createPattern() {
      const patterns = ShiftPatternService.prepareRequestData(this.selectedShiftsByDay, this.shiftLists);
      const request = {
        pattern_name: this.pattern_name,
        patterns: patterns
      };
      axios.post('/shift-pattern', request)
      .then((response) => {
        this.disabled = true;
        if (response.data) {
          this.showList();
          this.$notification.success('Shift Pattern created successfully', {
            timer: 3,
            position: "bottomCenter"
          })
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else if (error.response.status == 500) {
          this.$notification.error('Failed to update shift pattern', {
            timer: 3,
            position: "bottomCenter"
          })
        } else if (error.response.status == 422) {
          let errors = error.response.data.errors;
          this.printValidationError(error.response);
          if (errors.shift_patterns && errors.shift_patterns) {
            this.shiftErrorData = errors.shift_patterns;
          }
        } else if (error.response.status == 403) {
          this.$notification.error(error.response.data.message, {
            timer: 3,
            position: "bottomCenter"
          })
        }
        this.disabled = false;
        console.log("Shift Pattern Create API Error", error);
      })
    },

    getSpecificShiftErrorMessage(shiftId, dayId) {
      return ShiftPatternService.defineOverlapErrMsg(shiftId, dayId, this.shiftErrorData)
    },

    handleDayChange(dayId) {
      return ShiftPatternService.defineDayChange(dayId, this.selectedDays, this.selectedShiftsByDay, this.shiftLists, this.$set);
    },

    handleShiftChange(dayId) {
      this.shiftErrorData = null;
      return ShiftPatternService.defineShiftChange(dayId, this.selectedDays, this.selectedShiftsByDay, this.$set);
    },
  },

  created() {
    ShiftPatternService.initDays(
      this.days,
      this.selectedDays,
      this.selectedShiftsByDay,
      this.$set
    );
  },

  computed: {
    hasAnyShiftSelected() {
      return ShiftPatternService.hasAnyShiftSelected(this.selectedShiftsByDay)
    },

    hasAnyDaySelected() {
      return ShiftPatternService.hasAnyDaySelected(this.selectedDays)
    },

    showGlobalPatternError() {
      return this.submitted && !this.hasAnyShiftSelected && !this.hasAnyDaySelected;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getShiftLists();
  },
};

function removeValidationError(el) {
  const next = el.nextElementSibling;
  if (next && next.classList.contains('validation-error')) {
    next.remove();
  }
}

function insertValidationError(el, message) {
  const div = document.createElement('div');
  div.className = 'text-danger validation-error';
  div.textContent = message;
  el.after(div);
}
